const ROUTE_PATHS = {
  SETTINGS: '/settings',
  DASHBOARD: '/dashboard',
  // TEST: '/checking',
  TELEKARDIA_DASHBOARD: '/telekardia/dashboard',
  TELEKARDIA_APPOINTMENTS: '/telekardia/appointments',
  TELEKARDIA_ALL_APPOINTMENT: '/telekardia/all-appointments',
  TELEKARDIA_ADMIN_DASHBOARD: '/admin/dashboard',
  TELEKARDIA_ADMIN_FEEDBACKS: '/admin/feedbacks',
  TELEKARDIA_ADMIN_CONSULTATIONS: '/admin/consultations',
  TELEKARDIA_ADMIN_CALENDAR: '/admin/calendar',
  /* report paths */
  EXPORTS: '/exports',
  REPORTS: '/reports',

  /* Clinician paths */
  CLINICIAN_HOME: '/clinician/home',
  CLINICIAN_ECGLIST: '/clinician/ecglist',
  CLINICIAN_STETH_LIST: '/clinician/stethIOlist',
  CLINICIAN_REPORT: '/clinician/report',
  CLINICIAN_RESOURCE: '/resources',
  CLINICIAN_REVIEW: '/clinician/ecglist/review/:id/:completed',
  CLINICIAN_ADMIN_REVIEW: '/admin/clinician/ecglist/review/:id/:completed',
  CLINICIAN_ADMIN_HOME: '/admin/clinician/home',
  CLINICIAN_ADMIN_ECGLIST: '/admin/clinician/ecglist',
  CLINICIAN_ADMIN_REPORT: '/admin/clinician/report',
  CLINICIAN_ADMIN_RESOURCE: '/admin/resources',

  /* patient paths */
  // PATIENTS_DIRECTORY: '/patients/directory',
  PATIENTS_PATIENT_FILE: '/patients/patient-file',
  PATIENTS_ADD_NEW_PATIENT: '/patients/add-new-patient',
  PATIENTS: '/patients',
  SEARCH: '/search',
  PATIENTS_SEARCH_HOME: '/patients/search',

  /* ecg paths */
  EKG_REVIEW_EKG_RECORDING: '/ekg-review/recordings/ekg',
  EKG_REVIEW: '/ekg-review',
  QT_EKG_REVIEW: '/qt-ekg-review',
  EKG_RECORDING: '/ekg-recording/:recordingId',

  // IDTF Routes
  IDTF_KARDIA_RX: '/idtf/kardia-rx',
  PATIENT_ENROLLMENT: '/idtf/kardia-rx/patient/enroll-patient',

  // CCT-IDTF
  EKG_REVIEW_EKG_ANNOTATION: '/cct/annotator',
  CCT_WORK_LIST: '/cct/work-list',
  CCT_PATIENTS_LIST: '/cct/patients-list',

  // Inventory
  INVENTORY_LMP: '/inventory/lmp',
  INVENTORY_IMP: '/inventory/imp',
  // EOS E-Sign
  IDTF_E_Sign: '/:participantId/eos/:eos_id/e-sign',
};
export default ROUTE_PATHS;



// WEBPACK FOOTER //
// ./src/routes/routePaths.js